module.exports = __webpack_public_path__ + "media/images/illustrations/sticky-5d3745978753365ff6fc2e7069d34ed5.svg";